export const state = () => {
  return {
    counties: [],
    professionGroups: [],
    popularProfessions: [],
    popularProfessionsWithBlogs: [],
    popularProfessionTasks: [],
    phoneCountryCodes: [],
  };
};

export const getters = {
  popularProfessions: (state) => state.popularProfessions,
  popularProfessionsWithBlogs: (state) => state.popularProfessionsWithBlogs,
  popularProfessionTasks: (state) => state.popularProfessionTasks,
  counties: (state) => state.counties,
  professionGroups: (state) => state.professionGroups,
  phoneCountryCodes: (state) => state.phoneCountryCodes,
};

export const mutations = {
  setData(
    state,
    {
      counties,
      professionGroups,
      popularProfessions,
      popularProfessionsWithBlogs,
      popularProfessionTasks,
      phoneCountryCodes,
    }
  ) {
    state.counties = counties;
    state.professionGroups = professionGroups;
    state.popularProfessions = popularProfessions;
    state.popularProfessionsWithBlogs = popularProfessionsWithBlogs;
    state.popularProfessionTasks = popularProfessionTasks;
    state.phoneCountryCodes = phoneCountryCodes;
  },
};

export const actions = {
  async loadBackendData({ commit }, context) {
    try {
      context.$logger.info("loadBackendData start");
      const INIT_QUERY = await import("./initQ.graphql");
      const callQuery = () => {
        return context.$query(INIT_QUERY);
      };
      let resp;
      if (process.server) {
        const currentLocale =
          context.i18n?.locale || context.app?.i18n?.locale || "hu-HU";
        const cacheKey = `backendData-${currentLocale}`;
        resp = await context.$cachedData(cacheKey, 60 * 60 * 24, callQuery);
      } else {
        resp = await callQuery();
      }

      context.$logger.info("loadBackendData end");
      commit("setData", resp);
    } catch (err) {
      context.$logger.error(err);
      context.$sentry.captureException(err, {
        tags: {
          graphql: "storeInit",
        },
      });
    }
  },
};
